import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  DomainsByUserTypeApi,
  IntervenstionDomainsByUserTypeApi,
} from '../../../api/services/Intervention/getDomainById.service';

const initialState = {
  domain: [],
  loading: false,
};
interface Data {
  providerId: string;
  clientId: string;
  childPayerId: any;
}
interface IntervenstionData {
  clientId: string;
  organizationServiceId: any;
}
export const getDomainByUserTypeCall = createAsyncThunk(
  'getDomainByUserTypeCall',
  async (payload: Data, { rejectWithValue }) => {
    try {
      const res = await DomainsByUserTypeApi.getDomainByType(payload);
      return res.data.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
export const getInterVenstionDomainByUserTypeCall = createAsyncThunk(
  'getInterVenstionDomainByUserTypeCall',
  async (payload: IntervenstionData, { rejectWithValue }) => {
    try {
      const res = await IntervenstionDomainsByUserTypeApi.getDomainByType(payload);
      return res.data.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
const getDomainsByType = createSlice({
  name: 'getDomains',
  initialState,
  reducers: {
    clearInterventionDomainData: state => {
      state.domain = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getDomainByUserTypeCall.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(getDomainByUserTypeCall.fulfilled, (state: any, action) => {
        state.domain = action.payload;
        state.loading = false;
      })
      .addCase(getDomainByUserTypeCall.rejected, (state: any) => {
        state.loading = true;
      })
      .addCase(getInterVenstionDomainByUserTypeCall.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(getInterVenstionDomainByUserTypeCall.fulfilled, (state: any, action) => {
        state.domain = action.payload;
        state.loading = false;
      })
      .addCase(getInterVenstionDomainByUserTypeCall.rejected, (state: any) => {
        state.loading = true;
      });
  },
});
export const { clearInterventionDomainData } = getDomainsByType.actions;
export default getDomainsByType.reducer;
